module.exports = __webpack_public_path__ + "static/img/step 4.c82fd99.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/step 4.gif
// module id = rsgi
// module chunks = 1